import React from 'react';

import {
  Button,
  Box,
  Typography,
  Modal,
  CircularProgress,
} from '@mui/material';

import StarIcon from '../../../../common/assets/icons/star_icon_blue.svg';
import './SubscriptionPurchasedModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  // subscription: AvailableAppSubscription;
};

const SubscriptionPurchasedModal: React.FC<Props> = ({
  open,
  loading = false,
  onClose,
  // subscription,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {loading && (
          <CircularProgress
            color='primary'
            size='64px'
            style={{ display: 'block', margin: '24px auto' }}
          />
        )}
        {!loading && (
          <div>
            <div className='star-container'>
              <img src={StarIcon} alt='Star' />
            </div>
            <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
              Thanks for your subscription!
            </Typography>
            {/*<Typography color="gray">*/}
            {/*  You just subscribed for the {subscription.name} plan for $*/}
            {/*  {subscription.monthlyCost} per month!*/}
            {/*</Typography>*/}
            <Button
              onClick={onClose}
              variant='contained'
              color='primary'
              disableElevation
              sx={{
                width: '100%',
                height: 48,
                marginTop: '20px',
                borderRadius: '15px',
              }}
            >
              <Typography color='white'>Ok, Got it!</Typography>
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default SubscriptionPurchasedModal;
